import { FC, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import useApi from 'utils/use-api';
import SearchSelectInput from 'components/core/search-select-input';
import _ from 'lodash';

interface AssignableGroupPickerProps {
  id: string;
  label?: string;
  required?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  handleBlur?: any;
}

const AssignableGroupPicker: FC<AssignableGroupPickerProps> = ({ id, label, required, setFieldValue, ...form }) => {
  const api = useApi();
  const { data, isLoading } = useQuery({
    queryKey: ['assignable-groups'],
    queryFn: async () => {
      const res = await api.get('/access-requests/assignable/groups');
      return res.data ?? [];
    },
  });

  const options = useMemo(
    () =>
      (data || []).map((group: any) => ({
        label: { title: group.name as string },
        value: Number(group.id),
      })),
    [data],
  );

  const handleSetValue = (field: string, val: any) => {
    const option = options.find((o: any) => _.isEqual(o.value, val));
    const rawId = typeof val === 'object' && val !== null ? (val.id ?? val.value ?? val) : val;
    const id = Number(rawId);
    const name = typeof val === 'object' && val !== null ? (val.name ?? val.label ?? option?.label.title ?? '') : (option?.label.title ?? '');

    setFieldValue('assigneeId', isNaN(id) ? 0 : id);
    setFieldValue('assigneeName', name);
    setFieldValue('assigneeType', 'group');
    setFieldValue(field, isNaN(id) ? '' : id);
  };

  return (
    <SearchSelectInput
      id={id}
      label={label ?? 'Select Group'}
      required={required}
      optionsLoading={isLoading}
      options={options}
      setFieldValue={handleSetValue}
      {...form}
    />
  );
};

export default AssignableGroupPicker;
